import {
  GenericNotificationCode,
  NotificationOptions,
  parseGenericNotification,
} from '../../../models/notification.model'

export type TaskNotificationCode = GenericNotificationCode | 'TASK_NOT_FOUND'

/**
 * Parse supplier order code to a notification
 * @param code - the supplier order notification code
 * @returns the notification options
 */
export function parseTaskNotification(
  code?: TaskNotificationCode,
): NotificationOptions {
  switch (code) {
    case 'TASK_NOT_FOUND':
      return {
        message: 'Supplier order not found',
        color: 'error',
      }
    default:
      return parseGenericNotification(code)
  }
}
